module.exports = __webpack_public_path__ + "static/media/logoJet2Holidays.4fe30f15.ico";